<template>
  <tm-popup :title="title" ref="historyPopup">
    <div class="check-in-history">
      <p v-if="isLoading" class="text-center text-grey my-6">جارٍ تحميل السجل...</p>
      <p v-else-if="!entries.length" class="text-center text-grey my-6">لا توجد تعديلات على حضور هذا المتطوع.</p>
      <ul v-else class="vx-timeline">
        <li v-for="entry in entries" :key="entry.id">
          <div class="timeline-icon" :class="`bg-${actionOf(entry.action).color}`">
            <feather-icon :icon="actionOf(entry.action).icon" svg-classes="text-white stroke-current w-5 h-5" />
          </div>
          <div class="timeline-info">
            <p class="font-semibold">{{ actionOf(entry.action).label }}</p>
            <span class="activity-desc">
              {{ statusLabel(entry.previousStatus) }} ← {{ statusLabel(entry.newStatus) }}
            </span>
            <p class="activity-desc">{{ actorLabel(entry) }}</p>
          </div>
          <small class="text-grey activity-e-time">{{ formatTime(entry.createdAt) }}</small>
        </li>
      </ul>
    </div>
  </tm-popup>
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import utilities from "@/app/shared/utilities/index";

const zadiSessionsRepo = RepositoryFactory.get("zadiSessionsRepository");

const ACTIONS = {
  check_in: { label: "تسجيل حضور", icon: "CheckIcon", color: "success" },
  status_change: { label: "تعديل الحالة", icon: "EditIcon", color: "warning" },
  delete: { label: "حذف التسجيل", icon: "Trash2Icon", color: "danger" },
};
const UNKNOWN_ACTION = { label: "-", icon: "ClockIcon", color: "primary" };

export default {
  name: "ZadiCheckInHistory",
  components: {
    TmPopup,
  },
  props: {
    sessionId: { type: String, required: true },
    // تسميات حالة الحضور كما تعرضها شاشة سجل الحضور
    statusLabels: { type: Object, required: true },
  },
  data() {
    return {
      volunteerId: null,
      volunteerName: "",
      entries: [],
      isLoading: false,
    };
  },
  computed: {
    title() {
      return this.volunteerName ? `سجل تعديلات الحضور - ${this.volunteerName}` : "سجل تعديلات الحضور";
    },
  },
  methods: {
    open(checkIn) {
      this.volunteerId = checkIn.volunteerId;
      this.volunteerName = checkIn.volunteer ? checkIn.volunteer.name : "";
      this.entries = [];
      this.$refs.historyPopup.open();
      this.fetchHistory();
    },
    async fetchHistory() {
      const volunteerId = this.volunteerId;
      this.isLoading = true;
      try {
        const response = await zadiSessionsRepo.fetchZadiCheckInHistory(this.sessionId, volunteerId);
        // فُتح سجل متطوع آخر قبل وصول الرد
        if (volunteerId !== this.volunteerId) return;
        this.entries = (response && response.data) || [];
      } catch (err) {
        // httpClient يعرض الخطأ
      } finally {
        if (volunteerId === this.volunteerId) this.isLoading = false;
      }
    },
    actionOf(action) {
      return ACTIONS[action] || UNKNOWN_ACTION;
    },
    statusLabel(status) {
      return status ? this.statusLabels[status] || status : "لم يتم التفقد";
    },
    actorLabel(entry) {
      const actor = entry.actorType === "supervisor" ? "مشرف" : "الإدارة";
      // الاسم كما كان وقت التعديل، وقد يغيب عن تعديلات الإدارة
      return entry.actorName ? `${actor}: ${entry.actorName}` : actor;
    },
    formatTime(value) {
      return value ? utilities.formatDate(value, "yyyy-MM-DD HH:mm") : "-";
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>

<style scoped>
.check-in-history {
  max-height: 60vh;
  overflow-y: auto;
  padding-top: 8px;
}
</style>
